const resources = {
    pageTitle: 'Sign in for the best experience',
    personalizedBeautyTitle: 'Beauty advice tailored to you',
    perksTitle: 'Beauty Insider rewards & offers',
    adviceTitle: 'Guidance that improves over time',
    emailPlaceholder: 'Email address',
    passwordPlaceholder: 'Password',
    forgotPassword: 'Forgot password?',
    termsPrefix: 'By continuing, you agree to the current version of our',
    termsOfUse: 'TERMS OF USE',
    termsAnd: 'and have read Sephora\’s',
    privacyPolicy: 'Privacy Policy',
    signInButton: 'Sign In',
    continueAsGuest: 'Continue as a Guest'
};

export default function getResource(label) {
    return resources[label];
}
